module.exports = __webpack_public_path__ + "static/img/limestone_256.7945ebe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/limestone_256.png
// module id = Tgj6
// module chunks = 0